import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const AdditionalDriversStyle = styled.div`
  .driver-wrapper {
    width: 280px;
    background: ${theme.tints.lightAubergine};
    padding: 0 ${theme.grid.spacing.base}px;
    display: flex;
    flex-direction: column;
    .driver-container {
      display: flex;
      flex-direction: column;
      padding: ${theme.grid.spacing.base}px 0;
      &:not(:last-child) {
        border-bottom: 1px solid ${theme.tints.aubergine};
      }
      .driver-name {
        display: flex;
        margin-top: ${theme.grid.spacing.xxs}px;
        .icon {
          height: 20px;
          width: 20px;
          margin: 0 ${theme.grid.spacing.xs}px 0 0;
          svg {
            height: 20px;
            width: 20px;
            fill: ${theme.primaryColours.aubergine.main};
          }
        }
      }
      .button {
        margin-top: ${theme.grid.spacing.s}px;
        background: ${theme.primaryColours.white.main};
        width: fit-content;
        height: 32px;
      }
    }
  }
  .add-driver-info {
    margin-top: ${theme.grid.spacing.s}px;
  }
  .bold {
    font-weight: bold;
  }
  .modal-info-container {
    margin: ${theme.grid.spacing.base}px 0;
    .modal-info {
      color: ${theme.primaryColours.aubergine.main};
      &:first-child {
        margin-bottom: ${theme.grid.spacing.s}px;
      }
    }
  }
  .remove-driver-button-container {
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.grid.spacing.base}px;
    .keep-driver-button {
      margin-top: ${theme.grid.spacing.s}px;
    }
  }
  .modal-link {
    color: ${theme.primaryColours.cyan.superDarkCyan};
    font-weight: bold;
    cursor: pointer;
    text-decoration: none;
  }
  .checkbox-container {
    border-radius: 4px;
    margin-top: ${theme.grid.spacing.base}px;
    p {
      text-transform: uppercase;
    }
    &.is-error {
      &::before {
        right: 12px !important;
        left: 12px !important;
      }
    }
  }
  .modal-button {
    height: 48px;
  }
  .icon__alert svg path {
    &:first-child {
      fill: ${theme.primaryColours.tangerine.main};
    }
    &:last-child {
      fill: ${theme.primaryColours.white.main};
    }
  }
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    .driver-wrapper {
      width: 390px;
      .driver-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .button {
          margin: 0 0 0 16px;
          height: 40px;
        }
      }
    }
    .checkbox-container {
      &.is-error {
        &::before {
          right: 38px !important;
          left: 38px !important;
        }
      }
    }
    .modal-info-container {
      margin: ${theme.grid.spacing.md}px 0;
    }
    .remove-driver-button-container {
      display: flex;
      flex-direction: row;
      .keep-driver-button {
        margin-left: ${theme.grid.spacing.base}px;
        margin-top: 0;
      }
    }
  }
`
